export default __webpack_public_path__ + "static/media/cny_2024-cn.bd75c69c.webp";